'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ModifiersShape = {};

exports.__exports = ModifiersShape;
